import { BasketSectionsType } from "../Modules/Basket/basketTypes"
import {
    DeliveryPayloadLocationType,
    DeliveryPayloadType,
    DeliveryType,
    IDeliveryFormExtraServiceItem
} from "../Types/MeetingPlanning/deliveryForm"
import { ICanteen, IUser } from "../Types/appTypes"
import { FormikValues } from "formik"

export const generateCreateOrderPayload = (kitchen: ICanteen, user: IUser | null, values: FormikValues, basketSections: BasketSectionsType) => {
    const { deliveryTime, MEETING_NAME, DELIVERY_TYPE, DELIVERY_LOCATIONS, OTHER_DELIVERY_LOCATION, MERCHANT_ORDER_NOTE, NUMBER_OF_SEATS, BUYER_PARTIES, extraServices } = values

    const meetingName = MEETING_NAME || ''
    const deliveryType = DELIVERY_TYPE || ''
    const deliveryLocation = DELIVERY_LOCATIONS || ''
    const otherDeliveryLocation = OTHER_DELIVERY_LOCATION || ''
    const otherMessage = MERCHANT_ORDER_NOTE || ''
    const seats = NUMBER_OF_SEATS || ''
    const buyerCustomerParty = BUYER_PARTIES || ''

    const getDimensionsList = Object.keys(values)
        .filter(key => key.startsWith('ACCOUNTING_DIMENSION'))
        .flatMap(key => values[key])
        .map(({ id, value }) => ({ id, value }));

    return {
        merchant: {
            id: kitchen.id
        },
        payment: {
            buyerCustomerParty: {
                id: buyerCustomerParty?.[0]?.value || null
            },
            method: "INVOICE",
            accounting: {
                dimensions: getDimensionsList?.length ? getDimensionsList : []
            }
        },
        deliveries: getMeetingPlanningDeliveries(deliveryType, deliveryLocation, otherDeliveryLocation, basketSections, deliveryTime, extraServices, seats),
        meetingDetails: {
            meetingName,
            organizers: [
                {
                    "type": "ORGANIZER",
                    "name": user?.displayName || ''
                }
            ]
        },
        orderNote: otherMessage ?? "",
        orderType: "MEETING_SERVICE"
    }
}

function getMeetingPlanningDeliveries(deliveryType: string, deliveryLocation: string, otherDeliveryLocation: string, basketSections: BasketSectionsType, time: string, extraServices: IDeliveryFormExtraServiceItem[], seats: number) {
    return Object.entries(basketSections).map(([_, section]) => ({
        type: deliveryType,
        ...(deliveryType === DeliveryPayloadType.DELIVERY && {
            deliveryLocation: deliveryLocation?.length
                ? { type: DeliveryPayloadLocationType.RESOURCE, id: deliveryLocation }
                : { type: DeliveryPayloadLocationType.OTHER_LOCATION, id: otherDeliveryLocation }
        }),
        deliveryTime: time,
        orderLines: [
            ...section.privateOrderLines.map(line => ({
                productId: line.product.id,
                items: line.amount,
                buyerParty: "PRIVATE"
            })),
            ...section.companyOrderLines.map(line => ({
                productId: line.product.id,
                items: line.amount,
                buyerParty: "COMPANY"
            }))
        ],
        extraServices,
        seats
    }))
}
